import { TextInput } from '@carbon/react';
import { useTranslation } from '@pos/i18n';
import type { CustomerInfo } from './ordersApi';

/** Customer name, phone and delivery address (snapshotted on the order). */
export function CustomerFields({
  value,
  onChange,
  withAddress,
  idPrefix,
}: {
  value: CustomerInfo;
  onChange(value: CustomerInfo): void;
  withAddress: boolean;
  idPrefix: string;
}) {
  const { t } = useTranslation();
  const field = (key: keyof CustomerInfo, label: string, maxLength: number, type = 'text') => (
    <TextInput
      id={`${idPrefix}-${key}`}
      type={type}
      labelText={label}
      value={value[key] ?? ''}
      maxLength={maxLength}
      onChange={(e) => onChange({ ...value, [key]: e.target.value || null })}
    />
  );
  return (
    <div className="pos-orders__fields">
      {field('name', t('orders.details.name'), 200)}
      {field('phone', t('orders.details.phone'), 30, 'tel')}
      {withAddress && (
        <>
          {field('street', t('orders.details.street'), 500)}
          {field('ward', t('orders.details.ward'), 200)}
          {field('province', t('orders.details.province'), 200)}
          {field('note', t('orders.details.addressNote'), 500)}
        </>
      )}
    </div>
  );
}
